<template>
  <div class="app" :class="{ impersonating }">
    <AppHeader/>
    <b-navbar v-if="impersonating" class="impersonate-nav-bar" toggleable="md" type="dark" variant="danger">
      <div>You are now impersonating <strong>{{fullName}}</strong></div>
    </b-navbar>
    <!-- <div class="navbar"></div> -->
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main">
        <breadcrumb :list="list" class="mb-0"/>
        <div :class="{
          container: containerNormal,
          'container-fluid': containerFluid,
          'h-100': fillHeight,
          'overflow-hidden': fillHeight
          }">
          <router-view></router-view>
        </div>
      </main>
      <AppAside/>
    </div>
    <AppFooter/>
  </div>
</template>

<script>
import userMixin from '@/mixins/user';
import { get } from 'lodash';
import nav from '../_nav';
import {
  Header as AppHeader,
  Sidebar,
  Aside as AppAside,
  Footer as AppFooter,
  Breadcrumb,
} from '../components/';

const filterItems = function filterItems(userData, configs) {
  return (item) => {
    let userType = true;
    if (item.userTypes && item.userTypes.length) {
      if (item.userTypes.indexOf(userData.type) < 0) {
        userType = false;
      }
    }
    let accessKey = true;
    if (typeof item.accessKey === 'string') {
      accessKey = !!get(userData.account.access, item.accessKey);
    }
    let filter = true;
    if (typeof item.filter === 'function') {
      filter = item.filter(userData, configs);
    }
    const pass = userType && accessKey && filter;

    if (pass && item.children) {
      item.children = item.children.filter(filterItems(userData));
    }

    return pass;
  };
};

export default {
  name: 'full',
  mixins: [userMixin],
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb,
  },
  data() {
    return {
    };
  },
  computed: {
    nav() {
      const configs = {
        isPrambananConfig: this.isPrambananConfig,
        isCOPPConfig: this.isCOPPConfig,
        isTRTConfig: this.isTRTConfig
        ,
      };
      const { userData } = this.$store.getters;
      const { items } = nav;
      return items.filter(filterItems(userData, configs));
    },
    name() {
      return this.$route.name;
    },
    fullName() {
      return this.$store.getters.userData.full_name;
    },
    list() {
      return this.$route.matched;
    },
    impersonating() {
      return this.$store.getters.impersonating;
    },
    minimizeSidebar() {
      return this.$store.getters.minimizeSidebar;
    },
    containerNormal() {
      return this.useContainer && !this.minimizeSidebar;
    },
    containerFluid() {
      return this.useContainer && this.minimizeSidebar;
    },
    useContainer() {
      return this.$store.getters.useContainer;
    },
    fillHeight() {
      return this.$store.getters.fillHeight;
    },
  },
};
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/containers/Full.vue